import { iscTenant } from './isc/tenant';
import { iscPalette } from './isc/palette';
import { iscAssets, iscSvgAssets } from './isc/assets';
import iscCopyOverlay from './isc/locales/en/common.json';
import { wcsTenant } from './wcs/tenant';
import { wcsPalette } from './wcs/palette';
import { wcsAssets, wcsSvgAssets } from './wcs/assets';
import wcsCopyOverlay from './wcs/locales/en/common.json';
import { FrontendTenantConfig, TenantAssets, TenantPalette, TenantSvgAssets } from './types';

/** Slug -> FE tenant config. Onboarding tenant N: add its own `<slug>/tenant.ts`, `<slug>/palette.ts`,
 *  `<slug>/assets.ts` (+ `<slug>/assets/**`) and a `tenant-domains.json` entry, then register all
 *  four here — no other file changes for the registry/resolver/env layer (success metric 8; see
 *  `docs/tenant-onboarding-checklist.md`). */
export const tenantRegistry: Record<string, FrontendTenantConfig> = {
  isc: iscTenant,
  wcs: wcsTenant,
};

export const paletteRegistry: Record<string, TenantPalette> = {
  isc: iscPalette,
  wcs: wcsPalette,
};

/** Phase 3 (D5) — the synchronous per-tenant asset map. */
export const assetsRegistry: Record<string, TenantAssets> = {
  isc: iscAssets,
  wcs: wcsAssets,
};

export const svgAssetsRegistry: Record<string, TenantSvgAssets> = {
  isc: iscSvgAssets,
  wcs: wcsSvgAssets,
};

/** Phase 4 (D8) — the ~16 company-mentioning `common` keys, verbatim per tenant, deep-merged over
 *  the base bundle at boot (`@app/language/configs/i18n.ts`). Typed `unknown` deliberately: i18next's
 *  own `addResourceBundle(lng, ns, resources: any, ...)` is the only consumer, so no cast is needed
 *  to hand it off, and `unknown` avoids introducing our own `any` (forbidden on the frontend). */
export const copyOverlayRegistry: Record<string, unknown> = {
  isc: iscCopyOverlay,
  wcs: wcsCopyOverlay,
};
